(function(){
  if (window.__spFinalRingExtrasInit) return;
  window.__spFinalRingExtrasInit = true;

  var LABEL = { euroshank: "Euroshank", twotone: "Two-tone finish", birthstone: "Birthstone accent" };
  var DETAIL = { euroshank: "Squared shank with a flat base — resists spinning on the finger.", twotone: "White gold head on your yellow gold band, same karat." };
  var BIRTH_COLOR = {
    'January':'#7B1F2B','February':'#7B3BA6','March':'#7FC7D9',
    'April':'#E8ECEF','May':'#1F6F4A','June':'#4A7C5C',
    'July':'#9B1B2F','August':'#8BAD3B','September':'#0F3D8A',
    'October':'#C94B7D','November':'#CB8A1E','December':'#30A8A0'
  };
  var ICON = {
    euroshank:  '<img src="https://cdn.shopify.com/s/files/1/0708/5876/8690/t/205/assets/sp-euroshank.png?v=1776824168" alt="" style="width:100%;height:100%;object-fit:contain;display:block;" aria-hidden="true">',
    twotone:    '<img src="https://cdn.shopify.com/s/files/1/0708/5876/8690/t/205/assets/sp-twotone.png?v=1776824388" alt="" style="width:100%;height:100%;object-fit:contain;display:block;" aria-hidden="true">',
    birthstone: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="24" cy="24" r="14"/><polygon points="24,14 31,17 34,24 31,31 24,34 17,31 14,24 17,17"/><line x1="24" y1="10" x2="24" y2="14"/><line x1="34" y1="14" x2="31" y2="17"/><line x1="38" y1="24" x2="34" y2="24"/><line x1="34" y1="34" x2="31" y2="31"/><line x1="24" y1="38" x2="24" y2="34"/><line x1="14" y1="34" x2="17" y2="31"/><line x1="10" y1="24" x2="14" y2="24"/><line x1="14" y1="14" x2="17" y2="17"/></svg>'
  };

  function birthstoneIcon(color){
    // Round-brilliant gem outline with inner octagon filled in the stone
    // color. Outline stays navy for brand consistency.
    var fill = color || 'transparent';
    return '<svg viewBox="0 0 48 48" fill="none" stroke="#0b1d2e" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="24" cy="24" r="14"/>' +
      '<polygon points="24,14 31,17 34,24 31,31 24,34 17,31 14,24 17,17" fill="' + fill + '" fill-opacity="0.88"/>' +
      '<line x1="24" y1="10" x2="24" y2="14"/>' +
      '<line x1="34" y1="14" x2="31" y2="17"/>' +
      '<line x1="38" y1="24" x2="34" y2="24"/>' +
      '<line x1="34" y1="34" x2="31" y2="31"/>' +
      '<line x1="24" y1="38" x2="24" y2="34"/>' +
      '<line x1="14" y1="34" x2="17" y2="31"/>' +
      '<line x1="10" y1="24" x2="14" y2="24"/>' +
      '<line x1="14" y1="14" x2="17" y2="17"/>' +
      '</svg>';
  }

  function fmt(cents){ var n = (cents || 0) / 100; return "$" + n.toLocaleString("en-US", { maximumFractionDigits: 0 }); }
  function escapeHtml(s){
    return String(s || "").replace(/[&<>"']/g, function(c){
      return { "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#39;" }[c];
    });
  }

  var cardInjected = false;
  var pendingCart  = null;

  function buildCardInto(anchor){
    var card = document.createElement("div");
    card.className = "sp-fre";
    card.hidden = true;
    card.setAttribute("data-sp-final-ring-extras", "");
    card.innerHTML =
      '<div class="sp-fre__eyebrow">Ring refinements</div>' +
      '<div class="sp-fre__sub"><em>Already in your bag</em> \u2014 crafted into your ring during production.</div>' +
      '<div class="sp-fre__list" data-sp-fre-list></div>' +
      '<div class="sp-fre__footer">' +
        '<span class="sp-fre__total-label">Refinements subtotal</span>' +
        '<span class="sp-fre__total-amount" data-sp-fre-total>$0</span>' +
      '</div>';
    anchor.parentNode.insertBefore(card, anchor.nextSibling);
    cardInjected = true;
    return card;
  }

  function findCard(){ return document.querySelector("[data-sp-final-ring-extras]"); }

  function render(cart){
    var card = findCard();
    if (!card) return;
    var listEl  = card.querySelector("[data-sp-fre-list]");
    var totalEl = card.querySelector("[data-sp-fre-total]");

    var items = (cart.items || []).filter(function(it){
      var p = it.properties || {};
      return p._extra_type && LABEL[p._extra_type];
    });

    if (!items.length){ card.hidden = true; listEl.innerHTML = ""; totalEl.textContent = fmt(0); return; }

    var total = 0;
    var html = items.map(function(it){
      var p = it.properties || {};
      var type = p._extra_type;
      var detail, iconHtml;
      if (type === "birthstone" && p.Birthstone){
        detail = '<em>' + escapeHtml(p.Birthstone) + '</em>';
        // Parse month from property to drive the tint.
        var monthMatch = p.Birthstone.match(/^([^\u00b7]+)/);
        var month = monthMatch ? monthMatch[1].trim() : '';
        iconHtml = birthstoneIcon(BIRTH_COLOR[month]);
      } else {
        detail = DETAIL[type] || "";
        iconHtml = ICON[type] || "";
      }
      var linePrice = it.final_line_price || it.line_price || (it.price * (it.quantity || 1));
      total += linePrice;
      return '<div class="sp-fre-row">' +
               '<div class="sp-fre-row__icon" aria-hidden="true">' + iconHtml + '</div>' +
               '<div class="sp-fre-row__text">' +
                 '<div class="sp-fre-row__name">' + escapeHtml(LABEL[type]) + '</div>' +
                 (detail ? ('<div class="sp-fre-row__detail">' + detail + '</div>') : "") +
               '</div>' +
               '<div class="sp-fre-row__price">' + fmt(linePrice) + '</div>' +
             '</div>';
    }).join("");

    listEl.innerHTML = html;
    totalEl.textContent = fmt(total);
    card.hidden = false;
  }

  function load(){
    return fetch("/cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(cart){ pendingCart = cart; if (cardInjected) render(cart); })
      .catch(function(e){ console.warn("[sp-final-ring-extras]", e); });
  }

  function init(){
    if (!document.getElementById("finalmainsection")) return;
    load();
    var anchor = document.querySelector("#finalmainsection .product-single__metal-diamond");
    if (anchor){ buildCardInto(anchor); if (pendingCart) render(pendingCart); else load(); return; }
    var obs = new MutationObserver(function(){
      var a = document.querySelector("#finalmainsection .product-single__metal-diamond");
      if (a && !cardInjected){ buildCardInto(a); if (pendingCart) render(pendingCart); else load(); obs.disconnect(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function(){ try { obs.disconnect(); } catch(_){} }, 20000);
  }

  if (document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", init); }
  else { init(); }
  ["cart:updated","cart:refresh","cart:build","refresh:cart"].forEach(function(n){ document.addEventListener(n, load); });
})();
